import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import mixpanel from 'mixpanel-browser';
import { Redirect } from 'react-router';
import { useUser } from '../contexts/UserContext';
import { Role } from '../types/types';
import ErrorView from './ErrorView';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const connectorInviteId = urlParams.get('connector-invite-id');

const AuthedHome = () => {
  const { userInfo } = useUser();
  const role = userInfo?.role;
  const profileId = userInfo?.profileId;

  const { user } = useAuth0();

  useEffect(() => {
    if (connectorInviteId && role === Role.Ent) {
      mixpanel.identify(user.sub);
      mixpanel.track('Login via Invitation Link', { ConnectorID: connectorInviteId });
      mixpanel.people.set_once({
        ConnectorID: connectorInviteId
      });
    }
  }, [user, role]);

  console.debug('role', role);
  console.debug('profileId', profileId);
  if (role === Role.Ent) {
    return (<Redirect to={`/entrepreneur/${profileId}`} />);
  } else if (role === Role.Connector) {
    return (<Redirect to='/connector/deals/new' />);
  } else {
    return (<ErrorView />);
  }
};

export default AuthedHome;
